import { Injectable } from '@angular/core';
import { LoginRequestBody } from '../models/login/login-request-body';
import { LoginResponseBody } from '../models/login/login-response-body';
import { Observable, timeout } from 'rxjs';
import { BaseCadouhApiService } from '../../../shared/services/base-cadouh-api.service';

export interface RefreshTokenResponseBody {
  access: string;
  access_expiration: string;
}

export interface ResetPasswordRequestOtpBody {
  email: string;
  otp_channel: 'EMAIL';
}

export interface VerifyOtpBody {
  email: string;
  otp: string;
}

export interface VerifyOtpResponseBody {
  reset_token: string;
}

export interface ResetPasswordConfirmBody {
  reset_token: string;
  new_password: string;
}

export interface ChangePasswordBody {
  old_password: string;
  new_password1: string;
  new_password2: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthApiService extends BaseCadouhApiService {

  login(requestBody: LoginRequestBody): Observable<LoginResponseBody> {
    return this.http.post<LoginResponseBody>(`${this.baseUrl}/auth/login`, requestBody, { headers: this.getRequestHeaders() }).pipe(
      timeout(30000) // 30 seconds read timeout
    );
  }

  logout(): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/logout`, null, { headers: this.getRequestHeaders() });
  }

  refreshAccessToken(refresh: string): Observable<RefreshTokenResponseBody> {
    return this.http.post<RefreshTokenResponseBody>(
      `${this.baseUrl}/auth/token/refresh`,
      { refresh },
      { headers: this.getRequestHeaders() },
    );
  }

  requestPasswordResetOtp(body: { email: string }): Observable<any> {
    // The dashboard is email-only; the backend requires an explicit otp_channel.
    const payload: ResetPasswordRequestOtpBody = { email: body.email, otp_channel: 'EMAIL' };
    return this.http.post(`${this.baseUrl}/auth/password-reset/request-otp/`, payload, { headers: this.getRequestHeaders() });
  }

  verifyPasswordResetOtp(body: VerifyOtpBody): Observable<VerifyOtpResponseBody> {
    return this.http.post<VerifyOtpResponseBody>(`${this.baseUrl}/auth/password-reset/verify-otp/`, body, { headers: this.getRequestHeaders() });
  }

  confirmPasswordReset(body: ResetPasswordConfirmBody): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/password-reset/confirm/`, body, { headers: this.getRequestHeaders() });
  }

  changePassword(body: ChangePasswordBody): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/password/change/`, body, { headers: this.getRequestHeaders() });
  }

}
